export default __webpack_public_path__ + "static/media/Logoverte_black.3124abe6.png";